export const getCUEGoals = (goals) =>
  goals.filter((goal) => !goal.explorerState.type || goal.explorerState.type === 'CUE');

export const getK8SGoals = (goals) => goals.filter((goal) => goal.explorerState.type === 'K8S');

export const getGoalById = (goals, id) => goals.find((g) => g.uuid === id);
